define('main',['require','exports','module'],function(require, exports, module) {
require(['config'], function () {
  require(['app'], function (app) {
    app.start();
  });
});

});
